import { Tag } from "@/models/tag";
import { Pagination } from "@/models/pagination";
import { ITag, TagState } from "@/types/tag";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<TagState, ITag> = {
  single: (state, single) => {
    state.single = new Tag(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Tag(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Tag();
    state.pagination = new Pagination();
  },
};

export default mutations;
